<ng-container
	*ngTemplateOutlet="
    customInputTemplate ? customInputTemplate.template : baseInput;
    context: {
      ref: this,
      control: control,
      name: formControlName,
      disabled: control.disabled,
      inputPlaceholder: inputPlaceholder
    }
  "
></ng-container>
<ng-template #baseInput>
	<input
		(keyup.enter)="input.blur()"
		[attr.class]="inputClass"
		[attr.id]="inputId"
		[attr.placeholder]="inputPlaceholder | translate"
		[formControl]="control"
		#input
		type="text"
	>
</ng-template>
